var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTak4Lengeh2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 30",
    style: {
      enableBackground: "new 0 0 60 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8,15.4H5.8c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5H8c0.3,0,0.5,0.2,0.5,0.5S8.3,15.4,8,15.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "7.6,11.4 7.6,18.4 10.4,14.9  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,30H0V0h60V30z M1,29h58V1H1V29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7,25.3H3.5V4.4h9.2V25.3z M4.5,24.4h7.3v-19H4.5V24.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9,15.4h-2.2c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h2.2c0.3,0,0.5,0.2,0.5,0.5S55.1,15.4,54.9,15.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "53.1,18.4 53.1,11.4 50.3,14.9  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2,25.3H48V4.4h9.2V25.3z M49,24.4h7.3v-19H49V24.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4,30c-0.3,0-0.5-0.2-0.5-0.5V0.8c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5v28.7C30.9,29.8,30.6,30,30.4,30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2,30c-0.3,0-0.5-0.2-0.5-0.5V0.8c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v28.7C15.7,29.8,15.5,30,15.2,30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2,30c-0.3,0-0.5-0.2-0.5-0.5V0.8c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v28.7C45.7,29.8,45.5,30,45.2,30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2,15.2h-5.1c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h5.1c0.3,0,0.5,0.2,0.5,0.5S40.4,15.2,40.2,15.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6,18.5c-0.3,0-0.5-0.2-0.5-0.5v-6.7c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v6.7C38.1,18.3,37.9,18.5,37.6,18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6,15.2h-5.1c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h5.1c0.3,0,0.5,0.2,0.5,0.5S25.9,15.2,25.6,15.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1,18.5c-0.3,0-0.5-0.2-0.5-0.5v-6.7c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5v6.7C23.6,18.3,23.4,18.5,23.1,18.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTak4Lengeh2);
export default __webpack_public_path__ + "static/media/tak_4_lengeh_2.3133fa414749708d1c04d91c43942c32.svg";
export { ForwardRef as ReactComponent };